<template>
  <div class="radio-group__box">
    <el-form ref="form" :inline="true" v-bind="$attrs" class="search-form">
      <el-form-item :label="label">
        <el-radio-group v-model="form.value" @change="radioChange">
          <template v-for="(item) in options" >
            <span class="group__item" v-if="!showRadio" :key="item[props.value]">
              <i class="el-icon-close" @click.stop="clearChange" v-if="showClose && form.value===((item[props.value]===undefined && item) || item[props.value])"></i>
              <el-radio-button :label="(item[props.value]===undefined && item) || item[props.value]">{{item[props.label]||item}}</el-radio-button>
            </span>
            <el-radio v-else :key="item[props.value]" :label="(item[props.value]===undefined && item) || item[props.value]">{{item[props.label]||item}}</el-radio>
          </template>

        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'yblRadioGroup',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: () => ''
    },
    checked: {
      type: String | Number,
      default: () => ''
    },
    showClose: { // 是否显示close
      type: Boolean,
      default: () => false
    },
    showRadio: { // 是否显示单选按钮
      type: Boolean,
      default: () => false
    },
    props: {
      type: Object,
      default () {
        return { label: 'label', value: 'value' }
      }
    }
  },
  data () {
    return {
      form: {
        value: ''
      }
    }
  },
  created () {
    let item = (this.options && this.options.length && this.options[0]) || {}
    this.form.value = (item.value === undefined && item) || item.value
    if (this.showRadio) {
      this.form.value = this.checked
    }
  },
  methods: {
    radioChange (val) {
      // this.$emit('change', this.form.value)
      this.$emit('update:checked', val)
      this.$emit('change', val)
    },
    clearChange () {
      this.form.value = ''
      this.radioChange('')
    }
  }
}
</script>

<style lang="less">
@color:#409EFF;
.radio-group__box{
  /* .el-radio-group{
    width: 100%;
    padding: 5px;
  } */
  .el-radio-button:first-child .el-radio-button__inner,
  .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    border-left: none;
    border-radius: 0;
  }
  .el-radio-button--small .el-radio-button__inner{
    font-size: 14px;
    font-weight: normal;
    padding: 0 15px;
  }
  .el-radio-button__inner{
    border: none;
    margin: 0 5px;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: @color;
    background-color: #FFF;
    box-shadow: none;
  }
  .group__item{
    position: relative;
  }
  .el-icon-close{
    position: absolute;
    top: -15px;
    right: 5px;
    z-index: 1000;
    font-size: 15px;
    cursor: pointer;
  }
  .is-active{
    .el-icon-close{
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/RadioGroup.vue